import React from 'react'
import { ThemeContext } from './../../theme/DarkMode';
import eitaa from '../../logo/eitaa-logo.svg'
import x from '../../logo/x-logo2.png'
import bale from '../../logo/bale-logo.png'
import instagram from '../../logo/instagram-logo.png'


export const SocialMedia = () => {
    const { theme } = React.useContext(ThemeContext);
    return (

        <div className='social-icons'>
            <div className='icon-wraaper'>
                <md-standard-icon-button href="https://www.instagram.com/ahil_app/?utm_source=qr&igshid=MzNINGNKZWQ4Mg%3D%3D">
                    <md-icon tabindex="-2" filled>
                        <img src={instagram} alt='twiiter icon' className='x-icon' />
                    </md-icon>
                </md-standard-icon-button>
                {theme === 'light' ?
                    <md-standard-icon-button href="https://t.me/ahilapp">
                        <md-icon tabindex="-2" filled>
                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-telegram" viewBox="0 0 16 16">
                                <path fill='#4174bf' d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0zM8.287 5.906c-.778.324-2.334.994-4.666 2.01-.378.15-.577.298-.595.442-.03.243.275.339.69.47l.175.055c.408.133.958.288 1.243.294.26.006.549-.1.868-.32 2.179-1.471 3.304-2.214 3.374-2.23.05-.012.12-.026.166.016.047.041.042.12.037.141-.03.129-1.227 1.241-1.846 1.817-.193.18-.33.307-.358.336a8.154 8.154 0 0 1-.188.186c-.38.366-.664.64.015 1.088.327.216.589.393.85.571.284.194.568.387.936.629.093.06.183.125.27.187.331.236.63.448.997.414.214-.02.435-.22.547-.82.265-1.417.786-4.486.906-5.751a1.426 1.426 0 0 0-.013-.315.337.337 0 0 0-.114-.217.526.526 0 0 0-.31-.093c-.3.005-.763.166-2.984 1.09z" />
                            </svg>
                        </md-icon>
                    </md-standard-icon-button>
                    :
                    <md-standard-icon-button href="https://t.me/ahilapp">
                        <md-icon tabindex="-2" filled>
                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-telegram" viewBox="0 0 16 16">
                                <path fill='#69a5ff' d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0zM8.287 5.906c-.778.324-2.334.994-4.666 2.01-.378.15-.577.298-.595.442-.03.243.275.339.69.47l.175.055c.408.133.958.288 1.243.294.26.006.549-.1.868-.32 2.179-1.471 3.304-2.214 3.374-2.23.05-.012.12-.026.166.016.047.041.042.12.037.141-.03.129-1.227 1.241-1.846 1.817-.193.18-.33.307-.358.336a8.154 8.154 0 0 1-.188.186c-.38.366-.664.64.015 1.088.327.216.589.393.85.571.284.194.568.387.936.629.093.06.183.125.27.187.331.236.63.448.997.414.214-.02.435-.22.547-.82.265-1.417.786-4.486.906-5.751a1.426 1.426 0 0 0-.013-.315.337.337 0 0 0-.114-.217.526.526 0 0 0-.31-.093c-.3.005-.763.166-2.984 1.09z" />
                            </svg>
                        </md-icon>
                    </md-standard-icon-button>
                }
                <md-standard-icon-button href="https://twitter.com/AhilApp?s=09">
                    <md-icon tabindex="-2" filled>
                        <img src={x} alt='twiiter icon' className='x-icon' />
                    </md-icon>
                </md-standard-icon-button>
            </div>
            <div className='icon-wraaper'>
                <md-standard-icon-button href="https://eitaa.com/ahilapp">
                    <md-icon tabindex="-2" filled>
                        <img src={eitaa} alt='eitaa icon' />
                    </md-icon>
                </md-standard-icon-button>
                <md-standard-icon-button href="https://ble.ir/ahilapp">
                    <md-icon tabindex="-2" filled>
                        <img src={bale} alt='bale icon' />
                    </md-icon>
                </md-standard-icon-button>
            </div>
        </div>
    )
}
